import createVersionStore from './versionStore'

/**
 * Versi katalog lokal. Di-bump setelah `syncCatalog` selesai → hook read
 * (grid/detail) re-query tanpa remount. Disiarkan ke tab lain.
 */
export const catalogVersion = createVersionStore('kledo-pos-catalog-version')

export const bumpCatalogVersion = catalogVersion.bump

export const useCatalogVersion = catalogVersion.useVersion
